import axios from 'axios'

export default axios.create({
  baseURL: window.app.model_list.api_base,
  headers: {
    'Content-Type': 'application/json'
  }
})
